<div class="loading" *ngIf="loadingServive.loading$ | async">
  <svg width="361" height="367" viewBox="0 0 361 367" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M276 0H361V68H306V38H276V0ZM12 92V38H276V68H306V168H245V58H66V168H12V136H38V92H12ZM12 92V136H0V92H12ZM186 168H125V122H186V168Z" fill="#EE67A4"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M34 293V168H88V293H34ZM96 332V367H13V293H34V332H96ZM294 332H96V303H267V168H328V252H294V332ZM294 332V344H348V252H328V332H294ZM147 168H208V239H147V168Z" fill="#35BDB8"/>
  </svg>
  <p>loading...</p>    
</div>
<router-outlet></router-outlet>